/**
 * @fileoverview
 * See `types.ts` for context on these symbols.
 */

export const VORTEXCLIENTNAME = "vortex client global";
export const VORTEXCLIENT = Symbol.for(VORTEXCLIENTNAME);
export const VORTEXFRAME = Symbol.for("vortex frame handle");
